//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('timeStampStartCorr', {
//        templateUrl: 'views/components/views/timeStampStartCorr/timeStampStartCorr.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'timeStampStartCorrService', 'ttGridFactory', function ($stateParams, stateService, utilityService, modalService, translateService, timeStampStartCorrService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let labourNo = $stateParams.labour_no;
            
//            let translations = {
//                error: '',
//                ok: ''
//            };
            
//            vm.model = {
//                edit: {},
//                lockedSave: false,
//                gridReady: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_timestampstartcorr_powtimes_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            });
            
//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await timeStampStartCorrService.getTimeStampStartCorr({ labour_no: labourNo }))[0];
//            }

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 2589,
//                    parameters: vm.model.edit
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.rebind();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                timeStampStartCorrService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                        stateService.back(2);
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL
            
//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'timestamp_start':
//                    case 'timestamp_end':
//                        if (utilityService.validateWatchValue(value, vm.model.edit[id]) !== true) return;

//                        vm.model.edit[id] = value;

//                        if (utilityService.validateParmsValue(vm.model.edit[id]) !== true) return;

//                        loadGrid();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadEdit();
//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
